if (!customElements.get('featured-products-carousel')) {
  const focusableSelector = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled])';

  const desktopNavigation = (nextEl, prevEl) =>
    nextEl ? { allowTouchMove: false, navigation: { addIcons: false, nextEl, prevEl } } : { allowTouchMove: true };

  const syncTabStops = (swiper) => {
    swiper.slides.forEach((slide) => {
      const isTabbable = slide.classList.contains('swiper-slide-fully-visible');
      slide.querySelectorAll(focusableSelector).forEach((el) => {
        if (isTabbable) {
          el.removeAttribute('tabindex');
        } else {
          el.tabIndex = -1;
        }
      });
    });
  };

  customElements.define(
    'featured-products-carousel',
    class FeaturedProductsCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const carousel = this.querySelector('.swiper');
        window.SwiperLoader.onVisible(carousel, this.dataset.swiperSrc, (Swiper) => this.initialize(Swiper, carousel));
      }

      initialize(Swiper, carousel) {
        const swiper = new Swiper(carousel, {
          slidesPerView: 1.5,
          centeredSlides: false,
          grabCursor: true,
          loop: true,
          watchSlidesProgress: true,
          a11y: {
            enabled: true,
            scrollOnFocus: false,
            prevSlideMessage: 'Previous product',
            nextSlideMessage: 'Next product',
          },
          breakpoints: {
            990: {
              slidesPerView: 4,
              centeredSlides: true,
              spaceBetween: 8,
              ...desktopNavigation(
                this.querySelector('.featured-products__nav-next'),
                this.querySelector('.featured-products__nav-prev')
              ),
            },
          },
        });

        ['transitionEnd', 'slideChangeTransitionEnd', 'breakpoint', 'update', 'observerUpdate'].forEach((eventName) => {
          swiper.on(eventName, () => syncTabStops(swiper));
        });
        syncTabStops(swiper);
      }
    }
  );
}
